export const AGE = 'age';
export const CITY = 'city';
export const CREATED_AT = 'createdAt';
export const EMAIL = 'email';
export const NAME = 'lastName';
export const PHONE_NUMBER = 'phoneNumber';
export const SER = 'ser';
